import { publicComponent } from './public.component';

export const publicStateName = 'app.public';

export const publicState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: publicStateName,
    url: '/public/:pageType',
    component: publicComponent.name
  });
};
